
import barba from '@barba/core';
import anime from 'animejs';

export default class{

	constructor(){
        barba.hooks.afterOnce((data) => {
            this.init()
        })
        barba.hooks.after((data) => {
            this.init()
        });
    }
    init (){
        const header = document.getElementById('l-header');
        const hamburger = document.getElementById('js-hamburger');
        var timeoutId ;
        window.addEventListener( "scroll", function () {
            header.classList.add( "scrolling" ) ;
            hamburger.classList.add( "scrolling" ) ;

            clearTimeout( timeoutId ) ;

            timeoutId = setTimeout( function () {
                header.classList.remove( "scrolling" ) ;
                hamburger.classList.remove( "scrolling" ) ;
            }, 400 ) ;
        } ) ;

        const heroCatch = document.querySelector("#hero--catch")
        if(heroCatch){
            let regexp = /[\u{3000}-\u{301C}\u{3041}-\u{3093}\u{309B}-\u{309E}]/mu;
            let heroPrimary = document.querySelectorAll('.hero-catch__row')
            if(heroPrimary.length > 0){
                heroPrimary.forEach( (h,i) => {
                    let pr_str = h.textContent.split("");
                    let str = "";
                    pr_str.map( s => {
                        str += "<span class='hero__str'>" + s  + "</span>";
                    })
                        
                    h.innerHTML = str;
                })
            }

            let heroSecondary = document.querySelectorAll('.hero--catch__secondary')
            if(heroSecondary){
                heroSecondary.forEach( (h,i) => {
                    let sc_str = h.textContent.split("");
                    let str = "";
                    sc_str.map( s => {
                        str += "<span class='hero__str'>" + s  + "</span>";
                    })
                        
                    h.innerHTML = str;
                })
            }
            setTimeout(function(){
                let str_animation =  anime.timeline();
                str_animation.add({
                    targets : '#hero--image',
                    scale: [1.1,1],
                    translateX: ["10%",0],
                    opacity:[0,1],
                    easing: "easeOutExpo",
                    duration:2000
                })
                str_animation.add({
                    targets : '.hero--catch__primary .hero__str',
                    scale: [1.3,1],
                    translateX: ["20%",0],
                    opacity:[0,1],
                    // translateX: function(el, i) {
                    //     let s =  anime.random(-20,20) ;
                    //     return [s,0];
                    // },
                    easing: "easeOutExpo",
                    delay: function(el, i) {
                        return (i * 30);
                    },
                    duration:2000
                },"-=1300")
                .add({
                    targets : '.hero--catch__secondary .hero__str',
                    
                    scale: [1.3,1],
                    translateX: ["20%",0],
                    opacity:[0,1],
                    
                    easing: "easeOutExpo",
                    delay: function(el, i) {
                        return (i * 30);
                    },
                    duration:800
                },"-=2000")
                .add({
                    targets : '.hero--catch__button',
                    
                    translateX: ["20%",0],
                    scale: [1.3,1],
                    opacity:[0,1],
                    
                    easing: "easeOutExpo",
                    duration:800
                },"-=2000")
            },600)
        }
        const setFillHeight = () => {
            const vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
        }
        
        let vw = window.innerWidth;
        
        window.addEventListener('resize', () => {
        if (vw === window.innerWidth) {
        // 画面の横幅にサイズ変動がないので処理を終える
            return;
        }
        
        // 画面の横幅のサイズ変動があった時のみ高さを再計算する
        vw = window.innerWidth;
        setFillHeight();
        });
        
        // 初期化
        setFillHeight();
    }
}